import { gql } from '@apollo/client'

const POSTCODE_IS_DELIVERABLE_QUERY = gql`
  query PostcodeIsDeliverableQuery($postcode: String!) {
    postcodeIsDeliverable(postcode: $postcode)
  }
`

export { POSTCODE_IS_DELIVERABLE_QUERY }
